import React, { useState, useEffect, useRef } from 'react';
import AuthContext from '../../../context/AuthProvider'
import { useContext } from "react"
import {useParams} from "react-router-dom"
import './detail.scss';
import MaterialTable from "material-table";
import {Modal, Button, TextField,   Accordion,
  AccordionSummary,
  AccordionDetails, } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ImageIcon from '@mui/icons-material/Image';
import {makeStyles} from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add'
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import CircularProgress from '@mui/material/CircularProgress';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import dataInsertar from '../../../constants/dataOdontogramInsertar'
import IconButton from '@mui/material/IconButton';

import {Switch, Stack, Typography, Snackbar, ImageList, ImageListItem, Dialog, DialogContent, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { data as newData } from '../../../constants';
// import Invoice from './invoicing/Invoice'
import Odontogram from '../odontogram/Odontogram'
import ControlPagos from './ControlPagos';
import Recetas from './Recetas';

import {validarCodigoDni} from '../../../constants/dni'
import {validarCurrency} from '../../../constants/moneda'

const DETAIL_URL = '/treatments/'
const GET_PATIENT = '/patients/'


const UPLOAD_URL = '/imghistory/';
// console.log('IMPRIMIENDO MONEDA '+moneda)


const getCurrentDate = () =>{
  let today = new Date();
  let month = today.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let days = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();

  today = today.getFullYear() + "-" + month + "-" + days;

  // console.log(today);
  return today
}

const useStyles = makeStyles((theme) => ({
    modal: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      ['@media (max-width:480px)']: { 
        width: 250,
      }
    },
    iconos:{
      cursor: 'pointer'
    }, 
    inputMaterial:{
      width: '100%'
    },
    inputMateriall:{
      width: '30%',
       
    },
    inputTotal:{
      width: '30%',
      backgroundColor: '#DFE0E4'
    }
  }));

const Detail = () => {
  const [selectedImage, setSelectedImage] = useState(null);
   const contexto = useContext(AuthContext)
   const [open, setOpen] = React.useState(false);
    const axiosPrivate = useAxiosPrivate();

    const {id} = useParams()

    const [data, setData]= useState([]); //state pacientes
    const [dataT, setDataT]= useState([]); //state tratamientos

    // const [modalInvoice, setModalInvoice]= useState(false)
    const [modalEliminar, setModalEliminar]= useState(false);
    const [modalVer, setModalVer]= useState(false);

    const [mostrar, setMostrar] = useState(false)
    const [mostrarEditar, setMostrarEditar] = useState(false)

    const [selectedFile, setSelectedFile] = useState(null);
    // const [imageUrl, setImageUrl] = useState('');
    //para insertar
    const Num1E = useRef(null)
    const Num2E = useRef(null)

    //para editar
    const Numero1E = useRef(null)
    const Numero2E = useRef(null)

    const styles= useStyles();
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
    
      setOpen(false);
    };
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      setSelectedFile(file);
    };

    const estadoInicial = {
      idP:id,
      _id:"",
      tratamiento: "",
      descripcion: "",
      total: "",
      acuenta:"",
      saldo:"",
      fecha: getCurrentDate(),
      estado: false,
      odonto: undefined,
      images: {},
      // recetas: {},
      // payments:""
    }
    const [paciente, setPaciente]=useState({
        idP:id,
        _id:"",
        tratamiento: "",
        descripcion: "",
        total: "",
        acuenta:"",
        saldo:"",
        fecha: "",
        estado: false,
        odonto: undefined, //enviar aqui ?
        images: {},
        // recetas: {},
        // payments:""
      })



      const columns= [
        { title: "N°", render: rowData => rowData.tableData.id + 1, width:'4%' },
        { title: 'Diagnóstico', field: 'tratamiento' },
        { title: 'Observaciones', field: 'descripcion' },
        { title: 'Fecha', field: 'fecha'},
        { title: 'A/Cuenta', field: 'acuenta', type: 'numeric'},
        { title: 'Saldo', field: 'saldo', type: 'numeric'},
        { title: `Total (${validarCurrency(contexto.auth.phone)})`, field: 'total', type: 'numeric'},
        { title: 'Estado',field: "estado",
        editable: false,
        render: (rowData) =>
          rowData && (
            <button style={{ fontFamily: "Helvetica",backgroundColor: rowData.estado ?  "#1AB188": "#F24E4F" , borderRadius:"5px", padding: "3px"}}
              color="secondary"
            >
              {
                rowData.estado ? "CANCELADO" : "PENDIENTE"
                
              }
              
            </button>
          )}
        
      ];
      const handleImageClick = (key) => {
        setSelectedImage(paciente.images[key]);
      };
      const handleCloseDialog = () => {
        setSelectedImage(null);
      };
    const peticionGet=async()=>{
        await axiosPrivate.get(GET_PATIENT+id)
        .then(response=>{
        //  console.log(response.data)
         setData(response.data);
        }).catch(error=>{
          console.log(error);
        })
    }

    const peticionGetT=async()=>{
      await axiosPrivate.get(DETAIL_URL+id)
      .then(response=>{
      console.log(response.data)
       setDataT(response.data);
      }).catch(error=>{
        console.log(error);
      })
  }

    const peticionPost=async()=>{
        await axiosPrivate.post(DETAIL_URL, paciente)
        .then(response=>{
          console.log(paciente)
          setDataT(dataT.concat(response.data));
          // abrirCerrarModalInsertar();
          setPaciente(estadoInicial)
          setMostrar((prev) => !prev)
          setOpen(true);
          

        }).catch(error=>{
          console.log(error);
          alert("Error al insertar por favor intente de nuevo")
          window.location.reload();
        })
    
      }

      const peticionDelete=async()=>{
        console.log(paciente._id)
        await axiosPrivate.delete(DETAIL_URL+paciente._id)
      
        .then(response=>{
          setDataT(dataT.filter(artista=>artista._id!==paciente._id));
          abrirCerrarModalEliminar();

          // setPaciente(estadoInicial)
        }).catch(error=>{
          console.log(error);
        })
      }
      const handleDeleteImage = async(key) =>{
        // const keyo = key
        await axiosPrivate.delete(`${UPLOAD_URL}${paciente._id}?valor=${key}`)
        // `${UPLOAD_URL}/${user._id}?valor=${'avt'}`
        .then(response=>{
          console.log(response.data)
          // setDataT(dataT.filter(artista=>artista._id!==paciente._id));
          // abrirCerrarModalEliminar();

          // setPaciente(estadoInicial)
          setPaciente(prevState=>({
            ...prevState,
            images : response.data.imageUrl
          }));
          peticionGetT()
        }).catch(error=>{
          console.log(error);
        })

        
      }

        
const peticionPut=async()=>{
        
        console.log(dataT)
        await axiosPrivate.put(DETAIL_URL+paciente._id, paciente)
        .then(response=>{
          var dataNueva= dataT;
          dataNueva.map(artista=>{
            if(artista._id===paciente._id){

              artista.tratamiento=paciente.tratamiento;
              artista.descripcion=paciente.descripcion;
              artista.fecha=paciente.fecha;
              artista.total=paciente.total;
              artista.acuenta=paciente.acuenta;
              artista.saldo=paciente.saldo;
              artista.estado=paciente.estado
              artista.odonto=paciente.odonto

            }
          });
          setDataT(dataNueva);
          setPaciente(estadoInicial)//reseteamos
          setMostrarEditar((prev) => !prev)              
          setOpen(true);

        }).catch(error=>{
          console.log(error);
        })
      }  

    function getOdontogramData(name){
        //con esta funcion enviamos datos de hijo a padre.
        console.log(name)
        setPaciente(prevState=>({
          ...prevState,
          odonto: name
        }));  
 
    }  
    const handleSubmit = (e) =>{
      e.preventDefault()  
      console.log('HANDLE SUBMIT')

      peticionPost()
  
    }
    const handleSubmitEdit = (e) =>{
      e.preventDefault()
      console.log('HANDLE SUBMIT EDIT')
      peticionPut()

    }  

    const handleChange=e=>{

           const {name, value, type, checked}=e.target;
            setPaciente(prevState=>({
              ...prevState,
              [name]: type === 'checkbox' ? checked : value
            })); 
         
              // console.log("no tendrias que entrar aqui")
              if(name == 'acuenta' || name == 'total'){
                const n1 = parseInt(Num1E.current.value)
                const n2 = parseInt(Num2E.current.value)
                // console.log(num1-num2)
                if(n2 >= n1){
                  setPaciente(prevState=>({
                    ...prevState,
                    saldo: 0,
                    estado: true
                  }));

                }else{
                  setPaciente(prevState=>({
                    ...prevState,
                    saldo: n1 - n2,
                    estado: false
                  }));
                  
                }
                // setPaciente(prevState=>({
                //   ...prevState,
                //   saldo: n1 - n2
                // }));               
              }   
                        
       }
      //hay dos handleChanges debido a que no se pudo identificar de donde provenia cada useRef Num1E y Numero1E... 
    const handleChangeEditar=e=>{

        const {name, value}=e.target;
        setPaciente(prevState=>({
          ...prevState,
          [name]: value
        })); 


          if(name == 'acuenta' || name == 'total'){
            const num1 = parseInt(Numero1E.current.value)
            const num2 = parseInt(Numero2E.current.value)

            if(num2 >= num1){
              setPaciente(prevState=>({
                ...prevState,
                saldo: 0,
                estado: true
              }));

            }else{
              setPaciente(prevState=>({
                ...prevState,
                saldo: num1 - num2,
                estado: false
              }));
              
            }             
          }               
   }

    useEffect(()=>{
      peticionGet();
      peticionGetT();
          
      }, [])
    

      const seleccionarArtista=(artista, caso)=>{
        console.log(artista)
        setPaciente(artista); //Linea clave ! 
       
        if(caso==="Editar"){
          console.log('EDITAR')
          // setPaciente(estadoInicial)
          setMostrarEditar((prev) => !prev)
          // peticionGetT();
         
          // setPaciente(paciente)

        }
        else if(caso==="Ver"){
          abrirCerrarModalVer()
        }
        else if(caso==="Eliminar"){
          abrirCerrarModalEliminar()
        }
        // else if(caso==="Invoice"){
        //   abrirCerrarModalInvoice()
        // }
    
      }
        
      const abrirCerrarModalEliminar=()=>{
        setModalEliminar(!modalEliminar);
      }
    
      const abrirCerrarModalVer = () =>{
        setModalVer(!modalVer)
      }  
      // const abrirCerrarModalInvoice=()=>{
      //   setModalInvoice(!modalInvoice);
      // }
     

      
      const bodyEliminar=(
        <div className={styles.modal}>
          <p>Estás seguro que deseas eliminar este registro <b>{paciente && paciente.tratamiento}</b>? </p>
          <div align="right">
            <Button color="secondary" onClick={()=>peticionDelete()}>Sí</Button>
            <Button onClick={()=>abrirCerrarModalEliminar()}>No</Button>    
          </div>    
        </div>
      )
      // const bodyInvoice=(
      //   <div className={styles.modal}>
      //     <Invoice nombre={data.nombre}/>
      //   </div>
      // )
      const handleUpload = () => {
        const formData = new FormData();
        formData.append('image', selectedFile);
        // console.log(formData)  
        // console.log(paciente._id)
        axiosPrivate
          .put(`${UPLOAD_URL}/${paciente._id}?valor=${'avt'}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
              // console.log(response.data.imageUrl)
              setOpen(true);
              // setImageUrl(response.data.imageUrl);
              setPaciente(prevState=>({
                ...prevState,
                images : response.data.imageUrl
              }));
              peticionGetT()
                      
          })
          .catch((error) => {
            console.error('Error uploading image: ', error);
          });
      };
      const action = (
        <>
          <Button color="secondary" size="small" onClick={handleClose}>
            DESHACER
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      );  
      const actualizarAcuenta = (sumaAcuenta, sumaSaldo, totalP) => {
        if(sumaAcuenta >= totalP){
          setPaciente((prevState) => ({
            ...prevState,
            acuenta: sumaAcuenta,
            saldo:sumaSaldo,
            total:totalP,
            estado: true
          }));
        }else{
          setPaciente((prevState) => ({
            ...prevState,
            acuenta: sumaAcuenta,
            saldo:sumaSaldo,
            total:totalP,
            estado: false
          }));

        }



      };   
    return (
      <div className='detalle'>
        <Snackbar
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
          message="Datos Guardados !"
          action={action}
        
          // action={action}
        />
        <div className='card-all'>
          <div className="card-header">
                <p><span>Paciente: </span>{data.nombre}</p>
          </div>
          <div className="card">
            {/* <div> */}
                 {/* <TextField focused label="Nombre" value={data.nombre} variant="filled" size="small"/>  */}
                 <TextField color="warning" focused label="Celular" value={data.celular} variant="filled" size="small"/>    
                 <TextField color="warning" focused label={validarCodigoDni(contexto.auth.phone)} value={data.ci} variant="filled" size="small"/>   
                 <TextField color="warning" focused label="Enfermedades/Alergias: "  value={data.alergias} variant="filled" size="small"/> 
                 <TextField color="warning" focused label="Dirección:" value={data.direccion} variant="filled" size="small"/>    
                 <TextField color="warning" focused label="Edad:" value={data.edad} variant="filled" size="small"/>     
                 <TextField color="warning" focused label="Fecha:" value={data.fecha} variant="filled" size="small"/>           
                  {/* <Link to="/">
                    <Button className="irAtras" variant="outlined">
                      👈 IR ATRAS
                    </Button>
                  </Link> */}
             {/* </div>    */}
          </div>  
        </div>        
          
 
    
        <Button
          style={{ display: mostrarEditar || mostrar ? "none" : "" }}
          className="insertar"
          onClick={() =>{
             setMostrar((prev) => !prev)
             setPaciente(estadoInicial) //ES CLAVE PARA LIMPIAR ODONTOGRAM
            }}
        >
            {" "}
            <AddIcon /> Nuevo Tratamiento
        </Button>
        <br />
     

          {/* INSERTAR */}
        <form onSubmit={handleSubmit} id="dPaciente" style={{ display: mostrar ? "" : "none" }}>
          <div className="insertarView">
            <h3 className="tituloModal">Nuevo Tratamiento</h3>
            <br /> 
            <TextField
                className={styles.inputMaterial}
                label="Diagnóstico:"
                name="tratamiento"
                onChange={handleChange}
                value={paciente&&paciente.tratamiento}
                variant="outlined"
                required
            />
            <br />
            <br />            
            <TextField     
                // placeholder="Observaciones:"
                label="Observaciones:"
                // style={{ width: 200 }}
                onChange={handleChange}
                name="descripcion"
                className={styles.inputMaterial}
                value={paciente&&paciente.descripcion}
                variant="outlined"
                multiline
            
            />
            <br />
            <br />
            <TextField
              label="Fecha:"
              type="date"
              className={styles.inputMaterial}
              name="fecha"
              onChange={handleChange}
              value={paciente&&paciente.fecha}
              variant="outlined"
            />
             <br />
            <br />
            <div className="pagos">
              <br />
              <TextField
                className={styles.inputTotal}
                label="Total:"
                name="total"
                type="number"
                min="1"
                onChange={handleChange}
                value={paciente&&paciente.total}
                variant="outlined"   
                // id="Num1"
                inputRef={Num1E}
                        
              />
              <br />
              <TextField
                className={styles.inputMateriall}
                label="A/Cuenta:"
                name="acuenta"
                type="number"
                min="1"
                onChange={handleChange}
                value={paciente&&paciente.acuenta}
                variant="outlined"
                // id="Num2"  
                inputRef={Num2E}
              />
              <br />
              <TextField
                className={styles.inputMateriall}
                label="Saldo:"
                name="saldo"
                type="number"
                min="1"
                onChange={handleChange}
                value={paciente&&paciente.saldo}
                // value={total}
                variant="outlined"
                focused
              />
            </div>

            <br />
            <Stack direction="row" spacing={1}  style={{display:'flex', justifyContent:'center', alignItems:"center"}}> 
              <Typography><strong style={{ color: paciente.estado ? '#C8C9C4' : '#F74242' }}>PENDIENTE</strong> </Typography>
                  <Switch
                    checked={paciente.estado}
                    name='estado'
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                    type="checkbox"
                    id='checkState'
                    color="success"
                  />
              <Typography><strong style={{color: paciente.estado ? '#2E7D32' : '#C8C9C4'}}>CANCELADO</strong></Typography>
            </Stack>
   
      
            <br />
            <br />
          
                  <div className='odonto'>  
              <h3>Odontograma: </h3>  
              <br /> 
              {             
                paciente.odonto == undefined ?
                              <Odontogram getData={getOdontogramData} estadoPrueba={dataInsertar} /> 
                            :
                            console.log('DO NOT EXCUTE INSERTAR ODONTOGRAM')
              }      

            </div>
        
            <br />
   
            <div align="right">
              <Button onClick={()=> document.getElementsByClassName("doble")[0].click()} color="primary" type='submit' >
                Insertar
              </Button>
              <Button onClick={() => {
                // document.getElementsByClassName("doble")[0].click()
                // <Odontogram  getData={getOdontogramData} estadoPrueba={dataInsertar} /> 
                setPaciente(estadoInicial)
                // console.log(paciente.odonto)
                setMostrar(prev=> !prev)
                // window.location.reload();
              }}
                
                >Cerrar</Button>
            </div>
          </div>
        </form>

           {/* EDITAR */}
        <form onSubmit={handleSubmitEdit} id="dPaciente" style={{ display: mostrarEditar ? "" : "none" }}>
          <div className="insertarView">
            <h3 className="tituloModal">Editar Tratamiento</h3>
            <br />
            <TextField
              className={styles.inputMaterial}
              label="Diagnóstico:"
              name="tratamiento"
              onChange={handleChangeEditar}
              value={paciente&&paciente.tratamiento}
              required
              variant="outlined"              
            />
            <br />
            <br />
            
            <TextField
     
              // placeholder="Observaciones:"
              // style={{ width: 200 }}
              label="Observaciones:"
              onChange={handleChangeEditar}
              name="descripcion"
              className={styles.inputMaterial}
              value={paciente&&paciente.descripcion}
              variant="outlined"
              multiline
          
            />
            <br />
            <br />
            <TextField
              label="Fecha:"
              type="date"
              className={styles.inputMaterial}
              name="fecha"
              onChange={handleChangeEditar}
              value={paciente&&paciente.fecha}
              variant="outlined"
  
            />
             <br />
            <br />
    
            <h3>Odontograma: </h3> 
            <div className='odonto'> 
              
                {/* { console.log(paciente.odonto)} */}
                {
                paciente.odonto != undefined ?<Odontogram getData={getOdontogramData} estadoPrueba={paciente&&paciente.odonto}/> : console.log('DO NOT EXECUTE EDITAR ODONTOGRAM')
                }         
            </div>
              
            <br />
            <div>
              < Recetas
                              prescription={paciente.recetas}
                              idT={paciente._id}
                              // total={paciente.total}
                              concepto={paciente.tratamiento}
                              nombrePaciente={data.nombre}
                              fecha={getCurrentDate()}
                              peticionGetT={peticionGetT}                                   
              />
            </div>
            <br />
            <div >
              <ControlPagos
                paypay={paciente.payments}
                idT={paciente._id}
                total={paciente.total}
                concepto={paciente.tratamiento}
                nombrePaciente={data.nombre}
                fecha={getCurrentDate()}
                peticionGetT={peticionGetT}
                actualizarAcuenta={actualizarAcuenta}
             
              />
            </div>
            <div className="pagos">
                
                <TextField
                  className={styles.inputTotal}
                  label="Total:"
                  name="total"
                  type="number"
                  min="1"
                  onChange={handleChangeEditar}
                  value={paciente&&paciente.total}
                  variant="outlined"
                  id='Num1E'
                  inputRef={Numero1E}
                />
                <br />
                <TextField
                  className={styles.inputMateriall}
                  label="A/Cuenta:"
                  name="acuenta"
                  type="number"
                  min="1"
                  onChange={handleChangeEditar}
                  value={paciente&&paciente.acuenta}
                  variant="outlined"
                  id='Num2E'
                  inputRef={Numero2E}
                />
                <br />
                <TextField
                  className={styles.inputMateriall}
                  label="Saldo:"
                  name="saldo"
                  type="number"
                  min="1"
                  onChange={handleChangeEditar}
                  value={paciente&&paciente.saldo}
                  variant="outlined"
                />
                <br />
            </div>
          
            <br />
            <Stack direction="row" spacing={1}  style={{display:'flex', justifyContent:'center', alignItems:"center"}}> 
              <Typography><strong style={{ color: paciente.estado ? '#C8C9C4' : '#F74242' }}>PENDIENTE</strong> </Typography>
                  <Switch
                    checked={paciente.estado}
                    name='estado'
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                    type="checkbox"
                    id='checkState'
                    color="success"
                  />
              <Typography><strong style={{color: paciente.estado ? '#2E7D32' : '#C8C9C4'}}>CANCELADO</strong></Typography>
            </Stack> 
      <Accordion className='imagenesA'>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
        
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ImageIcon />
            <h3 style={{ margin: '0', marginLeft: '8px' }}>Imagenes</h3>
          </div>
        </AccordionSummary>
        <AccordionDetails className="imagenesA">
          <div>
            <br />
            <div className="file-upload">
              <label htmlFor="fileInput" className="custom-square">
                {selectedFile ? (
                  <img src={URL.createObjectURL(selectedFile)} alt="Selected" />
                ) : (
                  <span>Seleccionar Imagen</span>
                )}
                <input type="file" id="fileInput" onChange={handleFileChange} />
              </label>
              <button
                className="upload-button"
                onClick={(e) => {
                  e.preventDefault();
                  handleUpload();
                  setSelectedFile(null);
                }}
              >
                Subir Imagen
              </button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {paciente.images && Object.keys(paciente.images).length > 0 && (
  <ImageList sx={{ width: 500, height: 450 }} cols={2} rowHeight={164}>
    {Object.keys(paciente.images).map((key) => (
      <ImageListItem key={key}>
        <IconButton
          onClick={() => handleDeleteImage(key)}
          style={{ position: 'absolute', top: 8, right: 8, color: 'white' }}
        >
          <DeleteIcon />
        </IconButton>
        <img
          onClick={() => handleImageClick(key)}
          src={`${newData.urls.urlUpload}${paciente.images[key]}`}
          alt={key}
          loading="lazy"
        />
      </ImageListItem>
    ))}
  </ImageList>
)}

            </div>
            <Dialog open={!!selectedImage} onClose={handleCloseDialog}>
              <DialogTitle>Imagen a tamaño completo</DialogTitle>
              <DialogContent>
                {selectedImage && (
                  <img
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                    src={`${newData.urls.urlUpload}${selectedImage}`}
                    alt="Imagen a tamaño completo"
                  />
                )}
              </DialogContent>
            </Dialog>
          </div>
        </AccordionDetails>
      </Accordion>

            <div align="right">
              <Button color="primary" onClick={()=> document.getElementsByClassName("doble")[0].click()} type='submit'>Guardar</Button>
              <Button onClick={()=>{
                setPaciente(estadoInicial)
                setMostrarEditar(prev => !prev)}}>Cancelar</Button>
            </div>
            
          </div>
        </form>

        

        <br />

        <div style={{ display: mostrarEditar || mostrar ? "none" : "" }}>
          <MaterialTable         
            columns={columns}
            data={dataT}
            title="Historial del Paciente"
            actions={[
              {
                icon: 'visibility',
                tooltip: "Ver - Editar Registro",
                iconProps: { style: {color: "#111B21" } },
                onClick: (event, rowData) =>{
                  seleccionarArtista(rowData, "Editar")
                  setSelectedFile(null)
                }
              },
              {
                icon: "delete",
                iconProps: { style: { color: "#F24E4F"} },
                tooltip: "Eliminar Registro",
                onClick: (event, rowData) =>
                  seleccionarArtista(rowData, "Eliminar"),
              },

            ]}
            options={{
              exportButton: true,
              actionsColumnIndex: -1,
              headerStyle: {
                backgroundColor: "#23272A",
                color: "#FFFFFF",
              },
              rowStyle: {
                backgroundColor: "#EEE",
                fontSize: '16px',
                overflowWrap: 'break-word'
                
              },

            }}
            localization={{
              header: {
                actions: "Acciones",
              },
              body: {
                emptyDataSourceMessage:
                  //  <CircularProgress />
                  "No hay registros ",
              },
            }}
          />
        </div> 
  
        <Modal open={modalEliminar} onClose={abrirCerrarModalEliminar}>
          {bodyEliminar}
        </Modal>

      </div>
    );
}
 
export default Detail;